import { memo } from "react";

import { tw } from "classnames";

const styles = {
  addToCartButton: tw("h-12", "w-full", "rounded", "bg-placeholder"),
};

const AddToCartButtonPlaceholderBase = () => {
  return <div className={styles.addToCartButton}></div>;
};

export const AddToCartButtonPlaceholder = memo(AddToCartButtonPlaceholderBase);
